import { HelpCircle, Search } from "lucide-react";
import type { ReactNode } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type Props = {
  total: number;
  q: string;
  onQChange: (v: string) => void;
  children: ReactNode;
};

export default function MessengerPageShell({ total, q, onQChange, children }: Props) {
  return (
    <div className={cn("messenger-page -mx-8 -my-8 min-h-screen")}>
      <header className="border-b border-slate-200 bg-white px-6 py-6 lg:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900">
                Historie Messenger
              </h1>
              <p className="mt-1 max-w-xl text-sm text-slate-600">
                Prywatne wiadomości z inbox fanpage: historie życia, prośby o pomoc i pytania o
                produkt.
                <span
                  className="ml-1 inline-flex align-middle text-slate-400"
                  title="To nie komentarze pod rolkami, tylko prywatne DM w Messengerze."
                >
                  <HelpCircle className="h-3.5 w-3.5" />
                </span>
              </p>
            </div>
            <div className="flex w-full max-w-md items-center gap-3">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                <Input
                  className="border-slate-200 bg-slate-50 pl-9 text-slate-900 placeholder:text-slate-400"
                  placeholder="Szukaj w treści lub imieniu…"
                  value={q}
                  onChange={(e) => onQChange(e.target.value)}
                />
              </div>
              <div className="shrink-0 text-sm font-medium text-slate-600">
                {total} <span className="text-slate-400">historii</span>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-6xl px-6 py-6 lg:px-8">{children}</div>
    </div>
  );
}
